function toggleSearchBar(){
	$(".search_form").toggleClass("open");
}

$(document).ready(function(){

  

	$(document).mouseup(function(e) 
	{
		var searchBar = $(".search_form");

		// if the target of the click isn't the container nor a descendant of the container
		if (!searchBar.is(e.target) && searchBar.has(e.target).length === 0) 
		{
			searchBar.removeClass("open");
		}
	});

  /* code starts  25th dec */

  
  //$('[aria-current="page"]').parents('.nav_item').addClass('current-menu-item');

  // get stored the position and add active class
  let position = localStorage.getItem('store_cat_position');
  $(`.${position}`).addClass('current-menu-item');

  // onclick add active class
  $(".row ul li").click(function(e) {
      
      // parent li needs this class name appending in end current-menu-item
      
      var div_class_name = $(this).parents('.nav_item').prop('className');
    if(div_class_name){
      $(".nav_item").each(function (index) {
        $(this).removeClass('current-menu-item');
      })
      var classes = div_class_name.split(" ");
      let position = ''
      if(classes.length === 3) position = classes[classes.length-1]
      else position = classes[classes.length-2];


      localStorage.setItem('store_cat_position', position);
      $(`.${position}`).addClass('current-menu-item');
    }

});

$(".sub-menu li").click(function(e) {

      $(".nav_item").each(function (index) {
        $(this).removeClass('current-menu-item');
      })
      
      var div_class_name = $(this).parents('.nav_item').prop('className');
      var classes = div_class_name.split(" ");
      let position = ''
      if(classes.length === 3) position = classes[classes.length-1]
      else position = classes[classes.length-2];

      localStorage.setItem('store_cat_position', position);
      $(`.${position}`).addClass('current-menu-item');
})

  $(".nav_item ").click(function(e) {
    $(".nav_item").each(function (index) {
        $(this).removeClass('current-menu-item');
      })

    var div_class_name = $(this).prop('className');
      var classes = div_class_name.split(" ");
      let position = ''
      if(classes.length === 3) position = classes[classes.length-1]
      else position = classes[classes.length-2];

      localStorage.setItem('store_cat_position', position);
      $(`.${position}`).addClass('current-menu-item');
  })
  

  

  /* code ends 25th dec */
  
	$(document).mouseup(function(e) 
	{
		var page_nav = $(".page_header");

		// if the target of the click isn't the container nor a descendant of the container
		if (!page_nav.is(e.target) && page_nav.has(e.target).length === 0) 
		{
			$(".page_nav").removeClass("slide");
			$(".menu_toggle").removeClass("open");
			$("body").removeClass("menu-open");
		}
	});


  
	
	/*if($(".home-banner_section").length > 0){
		var scene = document.getElementById('scene');
		var parallaxInstance = new Parallax(scene);
	}*/

	$(".page_nav_list > .nav_item.menu-item-has-children > .nav_link").append('<i class="fa-solid fa-angle-down"></i>');



  
	$(".page_nav_list .nav_item i.fa-angle-down").click(function(e){
        e.preventDefault();
		$(this).parents(".nav_item").find(".mega-menu").slideToggle();
        $(this).parents(".nav_item").find(".sub-menu").slideToggle();
		$(this).parents(".nav_item").siblings(".nav_item").find(".mega-menu").slideUp();
        $(this).parents(".nav_item").siblings(".nav_item").find(".sub-menu").slideUp();
		$(this).parents(".nav_item").toggleClass("mega-menu-open");
		$(this).parents(".nav_item").siblings(".nav_item").removeClass("mega-menu-open");
	})

	$(".nav_item > .sub-menu").parent().addClass("has-sub-menu");

	$(".menu_toggle").click(function(){
		$(".menu_toggle").toggleClass("open");
		$(".page_nav").toggleClass("slide");
		$("body").toggleClass("menu-open");
	});

	if ($('.services_nav-tabs').length && $('.services-carousel').length) {
	$('.services_nav-tabs').on( 'click', 'button', function() {
		var filterValue = $(this).attr('data-filter');
		$('.services_nav-tabs button').removeClass('active');
		$(this).addClass('active');
        $(".services-carousel").slick('slickUnfilter');

        if (filterValue !== "*") {
            $('.services-carousel').slick('slickFilter', `${filterValue}`);
        }

	});
	}

	function initSlick(selector, options) {
		if (typeof $.fn.slick !== 'function') return;
		var $el = $(selector);
		if ($el.length) {
			$el.slick(options);
		}
	}

	$('.services-carousel').on('init.servicesInitialFilter', function() {
		var $carousel = $(this);
		setTimeout(function() {
			if (!$carousel.hasClass('slick-initialized')) return;
			var initialFilter = $carousel.attr('data-initial-filter') ||
				$('.services_nav-tabs .nav-link.active').attr('data-filter');
			if (!initialFilter || initialFilter === '*') return;
			$carousel.slick('slickUnfilter');
			$carousel.slick('slickFilter', initialFilter);
			if (!$carousel.find('.slick-slide:not(.slick-cloned)').length) {
				$carousel.slick('slickUnfilter');
			}
		}, 0);
	});

	initSlick('.services-carousel', {
        dots: false,
        infinite: true,
        speed: 600,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 4500,
		pauseOnHover: true,
		pauseOnFocus: false,
		responsive: [
			{
				breakpoint: 993,
				settings: {
				  slidesToShow: 3,
				  slidesToScroll: 1
				}
			  },
			{
			  breakpoint: 769,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			  }
			},
			{
				breakpoint: 767,
				settings: {
				  slidesToShow: 2,
				  slidesToScroll: 1,
				  variableWidth: true,
				}
			},
		]
	});

  initSlick('.home-banner_carousel', {
        dots: true,
        infinite: true,
        speed: 600,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4500,
        fade: true,
        pauseOnHover: true,
        pauseOnFocus: false
      });

	initSlick('.banner_carousel', {
        dots: true,
        infinite: true,
        speed: 600,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 4500,
		fade: true,
		pauseOnHover: false,
		pauseOnFocus: false
	});

	initSlick('.case_studies_carousel', {
        dots: true,
        infinite: true,
        speed: 600,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
		fade: false,
		pauseOnHover: true,
		pauseOnFocus: false
	});
	
	initSlick('.four-columns-carousel', {
        dots: false,
        infinite: true,
        speed: 600,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 4500,
		pauseOnHover: true,
		pauseOnFocus: false,
		responsive: [
			{
			  breakpoint: 769,
			  settings: {
				slidesToShow: 3,
				slidesToScroll: 1
			  }
			},
			{
				breakpoint: 767,
				settings: {
				  slidesToShow: 2,
				  slidesToScroll: 1,
				  variableWidth: true,
				}
			},
		]
	});

	initSlick('.three-columns-carousel', {
        dots: false,
        infinite: false,
        speed: 600,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 4500,
		pauseOnHover: true,
		pauseOnFocus: false,
		responsive: [
			{
			  breakpoint: 769,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
			  }
			}
		]
	});

	initSlick('.partners_carousel', {
        dots: false,
        infinite: true,
        speed: 600,
        arrows: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 4500,
		pauseOnHover: true,
		pauseOnFocus: false,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
				  slidesToShow: 4,
				  slidesToScroll: 1
				}
			  },
			{
			  breakpoint: 768,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			  }
			}
		]
	});

	// $('.location_carousel').slick({
    //     dots: false,
    //     infinite: true,
    //     speed: 1200,
    //     arrows: true,
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     autoplay: false,
    //     autoplaySpeed: 4500,
	// 	pauseOnHover: true,
	// 	pauseOnFocus: false,
	// 	centerMode: true,
	// 	centerPadding: '0px',
	// 	responsive: [
	// 		{
	// 		  breakpoint: 640,
	// 		  settings: {
	// 			slidesToShow: 1,
	// 			slidesToScroll: 1
	// 		  }
	// 		}
	// 	]
	// });

	/*$('[data-fancybox]').fancybox({
		youtube : {
			controls : 0,
			showinfo : 0
		},
		vimeo : {
			color : 'f00'
		},
	});*/
  if (typeof Fancybox !== 'undefined' && document.querySelector('[data-fancybox]')) {
  Fancybox.bind('[data-fancybox]', {
        Thumbs : {
          type: "classic"
        }
      });
  }

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
	gsap.registerPlugin(ScrollTrigger);

	if (document.querySelector('.speciality_section')) {
	ScrollTrigger.create({
		trigger: '.speciality_section',
		animation: gsap.fromTo('.speciality-carousel', {x: 400}, {x: 0, stagger: 0.3}),
		start: 'top 80%',
		end: 'bottom 90%',
		scrub: 1,
		markers: false,
	});
	}

	if (document.querySelector('.feature_prod_section')) {
	ScrollTrigger.create({
		trigger: '.feature_prod_section',
		animation: gsap.fromTo('.feature-carousel', {x: -400, opacity: 0}, {opacity: 100, x: 0, stagger: 0.3}),
		start: 'top 80%',
		end: 'bottom 90%',
		scrub: 1,
		markers: false,
	});
	}

	if (document.querySelector('.product_detail-banner')) {
	ScrollTrigger.create({
		trigger: '.product_detail-banner',
		animation: gsap.fromTo('.product_detail-banner .video_wrapper', {opacity: 1}, {opacity: 0, stagger: 0.3}),
		start: 'top 10%',
		end: 'bottom 30%',
		scrub: 1,
		markers: false,
	});
	}

	if (document.querySelector('.team_member_section .member_article')) {
	const teamTimeline = gsap.timeline({
          
    });
	let teamArticle = gsap.utils.toArray(".team_member_section .member_article");
	
	teamArticle.forEach((item, i) => {
		teamTimeline.to(item,{
			opacity: 0,
			y: '-10%',
			scale: 0.5,
			scrollTrigger: {
				trigger: ".member" + (i+1),
				scrub: true,
				start: "top 0%",
				end: "bottom 10%",
				markers: false,
			}
		});
	});
	}

	if (document.querySelector('.branch_location')) {
	$(".branch_location:nth-child(odd) .img_wrapper").addClass("wow fadeInLeft");
	$(".branch_location:nth-child(even) .img_wrapper").addClass("wow fadeInRight");

	const facilityTimeline = gsap.timeline({
          
    });
	let facility = gsap.utils.toArray(".branch_location");
	
	facility.forEach((item, i) => {
		facilityTimeline.to(item,{
			scrollTrigger: {
				trigger: ".location" + (i+1),
				scrub: true,
				start: "top 0%",
				end: "bottom 50%",
				markers: false,
				onEnter: () => translateListItem(i+1),
			}
		});
		function translateListItem(item){
			$(".location"+item).find(".list-style-bullet").addClass("translate")
		}
	});
	}

	if (document.querySelector('.our_location_section .location_carousel_wrapper')) {
	ScrollTrigger.create({
		trigger: '.our_location_section .location_carousel_wrapper',
		animation: gsap.fromTo('.our_location_section .location_carousel_wrapper', {scale: 0.6}, {scale: 1, stagger: 0.3}),
		start: 'top 90%',
		end: 'bottom 90%',
		scrub: 1,
		markers: false,
	});
	}
  }

	if ($('.wow').length && typeof WOW !== 'undefined') {
	new WOW().init();
	}

	$('.nav-tabs > .nav-item').click(function () {
        var index = $(this).index();
        var moveWidth = 0;
        for (j = index; j >= 1; j--) {
            var wth = $('.nav-tabs > .nav-item:nth-child(' + j + ')').outerWidth();
            if (wth != undefined)
                moveWidth = moveWidth + wth;
        }
        $('.nav-tabs').animate({
            scrollLeft: moveWidth
        });
    });

	$(".nav-tab_button").click(function(){
		$(this).parent().find(".nav-tabs").slideToggle();
	});

	var activeNav = $(".nav-link.active").text();

	$(".nav-tab_button").text(activeNav);

	if($(window).width() < 767){
		$(".nav-tabs-wrapper .nav-tabs .nav-item").click(function(){
			$(this).parents(".nav-tabs-wrapper").find(".nav-tabs").slideToggle();
			activeNav = $(this).text();
			$(".nav-tab_button").text(activeNav);
		})
	}

	if (typeof Swiper !== 'undefined' && document.querySelector('.location_carousel_wrapper .location_carousel')) {
	var swiper = new Swiper(".location_carousel_wrapper .location_carousel", {
		slidesPerView: 'auto',
		spaceBetween: 0,
		centeredSlides: true,
		preventClicks:true,
		loop:true,  
		speed: 1000,
		spaceBetween: 1,
    	slidesPerView: 1,
		breakpoints: {
			640: {
				slidesPerView: 3,
			},
		},
		navigation: {
			nextEl: '.location_carousel_wrapper .slick-prev',
			prevEl: '.location_carousel_wrapper .slick-next',
		},		
		on: {
		  init: function () {
			$('.swiper-slide').addClass('changed');
		  },
		  slideChangeTransitionStart : function() {
			$('.swiper-slide').addClass('changing');
			$('.swiper-slide').removeClass('changed');
		  },
		  slideChangeTransitionEnd : function() {
			$('.swiper-slide').removeClass('changing');
			$('.swiper-slide').addClass('changed');
		  }
		},
	  });
	}

});

var headerStickyTicking = false;
$(window).on('scroll', function(){
	if (headerStickyTicking) return;
	headerStickyTicking = true;
	window.requestAnimationFrame(function() {
		var scroll = $(window).scrollTop();
		if (scroll <= 150) {
			$(".page_header").removeClass("sticky");
		} else {
			$(".page_header").addClass("sticky");
		}
		headerStickyTicking = false;
	});
});

$(document).ready(function(){
    if ($("#testimonial-slider").length && $.fn.owlCarousel) {
    $("#testimonial-slider").owlCarousel({
        items:1,
        itemsDesktop:[1000,1],
        itemsDesktopSmall:[979,1],
        itemsTablet:[768,1],
        pagination:true,
        loop:true,
        animateOut: 'fadeIn',
        autoPlay:true
    });
    }
});


var accz = document.getElementsByClassName("accordionz");
var i;
for (i = 0; i < accz.length; i++) {
  accz[i].addEventListener("click", function() {    
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}
